import React, { Component } from 'react';
import './index.less'
class Home extends Component {
    render() {
        return (
            <div className='home-warp'>
                欢迎进入布里特安防公司管理系统  
            </div>
        );
    }
}

export default Home;